import colors from './colors'
import dataGrid from './data-grid'
import dateFormats from './date-formats'
import defaultValues from './default-values'
import fetchStatus from './fetch-status'
import limits from './limits'

const constants = {
  colors,
  defaultValues,
  limits,
  fetchStatus,
  dataGrid,
  dateFormats,
}

export default constants
